module.exports = __webpack_public_path__ + "static/rock-solid-borders-black-logo-5315771afd80e013125ba7a1f4e8836f.svg";